export default __webpack_public_path__ + "static/media/multi.824b9f8e.jpg";